import { Alert, Box, Stack, Tab, TabList, Tabs, tabClasses } from '@mui/joy';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { useAdmin } from '../../../AdminContext';


const SUB_ROUTES = {
    applications: '/admin/ads/applications',
    moderation: '/admin/ads',
    campaigns: '/admin/ads/campaigns',
    reports: '/admin/ads/reports',
    optimization: '/admin/ads/optimization',
    accounts: '/admin/ads/accounts',
    advertisers: '/admin/ads/advertisers',
    capacity: '/admin/ads/capacity',
    placements: '/admin/ads/placements',
    economics: '/admin/ads/economics',
};


export default function AdminAdsLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const { has } = useAdmin();

    if (!has('ads.view')) {
        return (
            <Alert color="warning">
                У вашей роли нет доступа к рекламному разделу. Нужно право <b>ads.view</b>.
            </Alert>
        );
    }

    const path = location.pathname;
    const value = path.startsWith('/admin/ads/applications')
        ? 'applications'
        : path.startsWith('/admin/ads/campaigns')
        ? 'campaigns'
        : path.startsWith('/admin/ads/optimization')
            ? 'optimization'
            : path.startsWith('/admin/ads/reports')
                ? 'reports'
            : path.startsWith('/admin/ads/accounts')
                ? 'accounts'
                : path.startsWith('/admin/ads/placements')
                    ? 'placements'
                : path.startsWith('/admin/ads/economics')
                    ? 'economics'
                : path.startsWith('/admin/ads/advertisers')
                    ? 'advertisers'
                : path.startsWith('/admin/ads/capacity')
                    ? 'capacity'
                    : 'moderation';

    return (
        <Box>
            <Tabs
                value={value}
                onChange={(_, v) => navigate(SUB_ROUTES[v] || '/admin/ads')}
                sx={{ bgcolor: 'transparent', mb: 2 }}
            >
                <TabList
                    variant="soft"
                    sx={{
                        borderRadius: 'md',
                        [`& .${tabClasses.root}.${tabClasses.selected}`]: {
                            bgcolor: 'primary.softBg', color: 'primary.700',
                        },
                    }}
                >
                    <Tab value="applications">Заявки</Tab>
                    <Tab value="moderation">Модерация</Tab>
                    <Tab value="campaigns">Все кампании</Tab>
                    <Tab value="reports">Отчёты</Tab>
                    <Tab value="optimization">Оптимизация</Tab>
                    <Tab value="advertisers">Рекламодатели</Tab>
                    <Tab value="accounts">Аккаунты</Tab>
                    <Tab value="capacity">Ёмкость</Tab>
                    <Tab value="placements">Площадки</Tab>
                    <Tab value="economics">Экономика</Tab>
                </TabList>
            </Tabs>

            <Outlet />
        </Box>
    );
}